import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import { quizService } from './quiz.service';
export function checkQuizVisibility(_x) {
  return _checkQuizVisibility.apply(this, arguments);
}
function _checkQuizVisibility() {
  _checkQuizVisibility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var quizId, userId, quizStatus, visible;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          quizId = _ref.quizId, userId = _ref.userId;
          _context.next = 3;
          return quizService.getStatus({
            userId: userId,
            id: quizId
          }, {
            useCache: true
          });
        case 3:
          quizStatus = _context.sent;
          visible = quizStatus === 'not seen';
          return _context.abrupt("return", visible);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _checkQuizVisibility.apply(this, arguments);
}